import { render, staticRenderFns } from "./MaterialAddForm.vue?vue&type=template&id=287b5fcd&"
import script from "./MaterialAddForm.vue?vue&type=script&lang=js&"
export * from "./MaterialAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports